import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Password must be at least 8 characters.");
    if (pw !== confirm) return toast.error("Passwords don't match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset. Please sign in.");
      nav("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream p-8">
      <div className="w-full max-w-sm bg-white rounded-xl border border-border p-8">
        <Link to="/" className="flex items-center gap-2.5 mb-6">
          <img src="/brand/ofr-mark.png" alt="OFR" className="w-9 h-9 rounded-md object-cover" />
          <div className="font-heading font-bold text-forest">Our First Realty</div>
        </Link>
        <h1 className="font-heading font-extrabold text-2xl text-forest tracking-tight">Set a new password</h1>
        {!token ? (
          <div className="mt-4 text-sm text-destructive">Missing or invalid reset link.</div>
        ) : (
          <form onSubmit={submit} data-testid="reset-form" className="space-y-3 mt-4">
            <div>
              <Label htmlFor="rp-pw" className="text-xs">New password (min 8)</Label>
              <Input id="rp-pw" data-testid="reset-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required />
            </div>
            <div>
              <Label htmlFor="rp-c" className="text-xs">Confirm password</Label>
              <Input id="rp-c" data-testid="reset-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
            </div>
            <Button type="submit" disabled={loading} data-testid="reset-submit" className="w-full h-11 bg-forest hover:bg-forest-hover text-white rounded-full">
              {loading ? "Saving…" : "Set new password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
